import React, { useEffect } from 'react'
import BannerData from '../models/BannersData'
import Banner from '../Components/banner/Banner'
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent'
import TitleComponent from '../Components/common/TitleComponent'
import { Typography } from '@material-tailwind/react'
import AboutUsSlider from '../Components/slider/AboutUsSlider'
import HomeAboutUsContent from '../Components/contents/HomeAboutUsContent'

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const BreadCrumbsPath = [
    {
      id: 1,
      pathName: "About us",
      pathLink: "/AboutUs",
    },
  ];

  return (
    <>
      {BannerData.filter(item => item.title === 'About Us').map((item) => (
        <Banner key={item.id} bannerDetails={item} />
      ))}

      <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

      {/* <TitleComponent Title={"Ceylon Hospital Wellness"} Subtitle={"We offer traditional therapies and holistic care to restore balance and rejuvenate your mind, body, and spirit."} /> */}
      {/* <TitleComponent Title={"Ceylon Hospital Wellness"} Subtitle={""} /> */}

      <div className='px-16'>

        {/* <Typography>
          Embark on a transformative journey at Adhitya Ayurveda, where personalized care blends the ancient wisdom of Ayurveda with
          Sri Lanka's Hela Wedakama to rejuvenate and restore balance to your mind and body.
        </Typography> */}

        {/* <AboutUsSlider /> */}

      </div>
      <HomeAboutUsContent />
    </>
  )
}

export default AboutUsPage